import Swiper, { Autoplay, Navigation, EffectCreative } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let testimonialsSwiperWr = document.querySelectorAll('.testimonials-swiper-wr');
testimonialsSwiperWr.forEach((el) => {
  if (el) {
    const testimonialsContainerEl = el.closest('.testimonials-sec__container');
    let testimonialsImagesArr = null;

    if (testimonialsContainerEl) {
      testimonialsImagesArr = testimonialsContainerEl.querySelectorAll('.testimonials-sec__image');
    }

    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    const updateImages = (index) => {
      if (testimonialsImagesArr && testimonialsImagesArr.length === slidesCount) {
        testimonialsImagesArr.forEach((img, i) => {
          img.classList.toggle('is-active', i === index);
          img.classList.toggle('is-hidden', i !== index);
        });
      }
    };

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, EffectCreative],
      observer: true,
      observeParents: true,
      spaceBetween: 20,
      slidesPerView: 1,
      threshold: 10,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          translate: [0, '-20px', 0],
          scale: 0.95,
        },
        next: {
          opacity: 0,
          translate: [0, '20px', 0],
          scale: 0.95,
        },
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on: {
        init(swiper) {
          updateImages(swiper.activeIndex);
        },
        slideChange(swiper) {
          updateImages(swiper.activeIndex);
        },
      },
    });
    swiperObserver(swiper);
  }
});